import { getCurrentInstance } from 'vue';

/**
 * Composable for toast notifications
 * Wraps $buefy.toast for use in Composition API
 */
export function useToast() {
    const { proxy } = getCurrentInstance();

    /**
     * Show a toast notification
     * @param {Object} options - Toast options
     * @param {String} options.message - Toast message
     * @param {String} options.type - Toast type (is-success, is-danger, is-warning, is-info)
     * @param {Number} options.duration - Duration in ms (default: 2000)
     * @param {String} options.position - Position (is-top, is-bottom, is-top-right, etc.)
     */
    function open(options) {
        proxy.$buefy.toast.open(options);
    }

    /**
     * Show a success toast
     * @param {String} message - Toast message
     */
    function success(message) {
        open({
            message,
            type: 'is-success'
        });
    }

    /**
     * Show an error toast
     * @param {String} message - Toast message
     */
    function error(message) {
        open({
            message,
            type: 'is-danger'
        });
    }

    /**
     * Show a warning toast
     * @param {String} message - Toast message
     */
    function warning(message) {
        open({
            message,
            type: 'is-warning'
        });
    }

    /**
     * Show an info toast
     * @param {String} message - Toast message
     */
    function info(message) {
        open({
            message,
            type: 'is-info'
        });
    }

    return {
        open,
        success,
        error,
        warning,
        info
    };
}
